import * as React from 'react';
import { ModalClickTrigger } from '../modals';
export default function Action({ modal, href, className, text, target, }) {
    if (modal) {
        return (React.createElement(ModalClickTrigger, { id: modal, className: className, text: text || '' }));
    }
    else if (href) {
        return (React.createElement("a", { href: href, className: className, target: target }, text));
    }
    return null;
}
//# sourceMappingURL=index.js.map